import { useState, useEffect } from "react";
import { getThemeVars } from "@/components/onboarding/OnboardingOverlay";

/**
 * useTheme hook — accepts user data (from useMe or useDashboard) as a parameter.
 * @param {{ theme?: string, onboarding_done?: boolean } | null | undefined} user
 */
export function useTheme(user) {
  const [themeId, setThemeId] = useState(user?.theme || "dark");
  const [onboardingDone, setOnboardingDone] = useState(
    user === undefined ? null : !!user?.onboarding_done
  );

  useEffect(() => {
    if (user) {
      if (user.theme) setThemeId(user.theme);
      setOnboardingDone(!!user.onboarding_done);
    } else if (user === null) {
      // User fetched but null — treat onboarding as done
      setOnboardingDone(true);
    }
  }, [user]);

  const applyTheme = (id) => setThemeId(id);

  const markDone = () => setOnboardingDone(true);

  return {
    themeId,
    themeVars: getThemeVars(themeId),
    onboardingDone,
    applyTheme,
    markDone,
  };
}
